import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import BigWinMediator from 'mediator/big-win-mediator';
import { GameType } from 'names/do-names';
import Layers from 'slotworks/graphics/layers/layers';
import campaignsModel from 'slotworks/integration/revolver/model/campaigns-model';
import autoplayModel from 'slotworks/model/autoplay-model';
import gameState from 'slotworks/model/game-state';
import BigWins from 'slotworks/state-machine/standard/states/big-wins';
import GameInit from './game-init';

export default class RevolverBigWin extends BigWins {
    public onEnter() {
        if (GameInit.gameType === GameType.default) {
            const bigWinMediator = new BigWinMediator();

            const wasPromoVisible = Layers.PromoBetBar.container.visible;
            bigWinMediator.start().then(bigWin => {
                if (wasPromoVisible && bigWin && campaignsModel.isFreespinsActive()) {
                    Layers.PromoBetBar.show();
                    Layers.SmartButton.show();
                }
                bigWinMediator.end();
                super.complete();
            });
        } else this.complete();
    }

    public onExit() {
        super.onExit();
        if (!gameState.getCurrentGame().inFreespinsGame && !autoplayModel.isAutoPlaying()) bonusBuyComponent.setEnabled(true);
    }
}



// WEBPACK FOOTER //
// ./src/states/revolver-big-win.ts